module.exports = __webpack_public_path__ + "img/1.08b3b4ab.jpg";